var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRentcompsDefault(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8984_487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3438 9.5625L28.9688 15.1875M28.9688 9.5625L23.3438 15.1875M23.3438 20.8125L28.9688 26.4375M28.9688 20.8125L23.3438 26.4375M23.625 4.21875H31.7812C33.3345 4.21875 34.5938 5.47798 34.5938 7.03125V28.9688C34.5938 30.522 33.3345 31.7812 31.7812 31.7812H4.21875C2.66548 31.7812 1.40625 30.522 1.40625 28.9688V7.03125C1.40625 5.47798 2.66548 4.21875 4.21875 4.21875H18M7.03125 9.5625L12.6562 15.1875M12.6562 9.5625L7.03125 15.1875M18 1.40625V34.5938",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03125 23.625L8.4375 26.4375L12.6562 20.8125",
    stroke: "#4CBC18",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8984_487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRentcompsDefault);
export default __webpack_public_path__ + "static/media/icon-rentcomps-default.0f489216c2ba1286358ddb84f2e06ee8.svg";
export { ForwardRef as ReactComponent };